import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Link as ScrollLink } from 'react-scroll'
import config from 'config'
import {
  Link,
  AndrewBeharSignature
} from '../'
import Styles from './PlanScorecardCompanyLetter.css'


@CSSModules(Styles, {allowMultiple: true})
export default class VisaCompanyLetter extends Component {
  static propTypes = {
    differentPage: PropTypes.bool,
  }

  constructor(props) {
    super(props)
    this.state = {
      differentPage: this.props.differentPage || false
    }
  }

  render() {
    const { differentPage } = this.state
    const sampleAd = require('../../../static/images/ads/visa_sample_ad.jpg')
    //
    return (
      <blockquote styleName='company-letter-blockquote'>

        <p><b>October 19, 2021</b></p>

        <p><b>Alfred F. Kelly Jr.<br/>
        Chief Executive Officer<br/>
        Visa Inc.<br/>
        900 Metro Center Blvd<br/>
        Foster City, CA<br/>
        94404</b></p>

        <p><b>Re: Visa employee retirement plan sustainability scorecard</b></p>

        <p>Dear Mr. Kelly,</p>

        <p>Visa is known to be a leader on climate change, highlighted by its 100 percent renewable electricity transition by 2020, along with its ambitious goal of achieving net-zero emissions across its value chain by 2030.</p>

        <p><b>However, your company retirement plan directly contradicts all of this hard work on your operations.</b></p>

        <p>I am writing to inform you about the recent release of <i>As You Sow’s</i> corporate retirement plan sustainability scorecard initiative and would like to extend an offer to meet and discuss our work. Below is a brief overview of the scorecard, where Visa is among the first companies rated.</p>

        <p>The corporate retirement plan sustainability scorecard initiative will empower the millions of U.S. employees holding trillions in retirement assets to invest their retirement savings sustainably. Many employees across the nation are unaware that their retirement plan investments are invested in climate change, prisons, weapons, and companies that score poorly on gender equality.</p>

        <p>We are using our <Link to={config.links.aysinvest} title='Invest Your Values - As You Sow' xstrong>expertise in mutual fund sustainability analysis</Link> and our extensive database of ESG-screened companies to rate corporations’ retirement plan investment options. Those investment options have been graded across seven major environmental and social issues, including deforestation, climate, and the prison industrial complex.</p>

        {
          differentPage ?
            (
              <p><b><Link to={config.routes.plans + '/visa'} title='Visa retirement plan sustainability scorecard' xstrong>The scorecard results for Visa's retirement plan</Link> directly contradict Visa leadership on climate change and other issues.</b></p>
            ) :
            (
              <p><b><ScrollLink to='scores' spy title='Visa retirement plan sustainability scorecard' smooth offset={-50} duration={500}><span styleName='scroll-link'>The scorecard results for Visa retirement plan</span></ScrollLink> directly contradict Visa leadership on climate change and other issues.</b></p>
            )
        }

        <p>Since 1992, <i>As You Sow</i> has had great success helping companies to adopt beneficial policies and practices on a range of environmental, social, and governance issues. The time is ripe for Visa to show its leadership by aligning its sustainability goals holistically across both operations and its retirement plan. We commend Visa in its efforts to build a sustainable business for all stakeholders and the planet, including ambitious climate goals and implementing them with action.</p>

        <p>While Visa has made significant efforts in addressing climate change and social issues across its operations, data obtained from Form 5500 SEC filings, along with information published by the Company for retirement plan participants, demonstrates a lack of alignment between the Company’s sustainability goals and its current retirement investment options offered through the Company’s employee retirement plan. Although Visa has establisheded its commitment to reducing its climate impact, the Company’s employee retirement plan currently does not have any ESG options available for employees who want to invest sustainably. Despite stated envorinmental and social goals, the Visa employee retirement plan is currently investing in companies profiting from the climate change and social inequality.</p>

        <p>Critically, the default plan option is not invested sustainably. Currently 32% of assets invested in the Visa employee retirement plan are invested in the default option target date funds. Because these funds are not invested sustainably, hundreds of millions of dollars in employee savings are being allocated to fossil fuel companies, deforestation-risk commodity producer/traders, and other sustainability risk sectors.</p>

        <p>Most employees assume the default option in their retirement plan is a safe choice. But if climate risk and other sustainability issues are not incorporated into the portfolio composition by the fund manager, employees could be exposed to financial risks from unsustainable investments. Asset managers recognize they have a fiduciary duty to mitigate the systemic risks of climate change: in 2020, <Link to={'https://www.blackrock.com/corporate/investor-relations/2020-blackrock-client-letter'} title='Sustainability as BlackRock’s New Standard for Investing' xstrong>major asset manager BlackRock announced</Link> "We intend to make sustainable funds the standard."</p>

        <p>If necessary, <i>As You Sow</i> will release ads into the social media feeds of Visa employees and customers that link them to a detailed scorecard of Visa’s retirement plan including a call to action.</p>

        <img
          src={sampleAd}
          alt='Visa Employees: Is Your 401k Investing in Fossil Fuels?'
          styleName='sample-ad-img'
        />

        {
          differentPage ?
            (
              <p><b>Visa's retirement plan is rated Poor on five of seven issue areas. The full results <Link to={config.routes.plans + '/visa'} title='Visa retirement plan sustainability scorecard' xstrong>can be found here.</Link></b></p>
            ) :
            (
              <p><b>Visa's retirement plan is rated Poor on five of seven issue areas. The full results <ScrollLink to='scores' spy title='Visa retirement plan sustainability scorecard' smooth offset={-50} duration={500}><span styleName='scroll-link'>can be found here.</span></ScrollLink></b></p>
            )
        }

        <p>Visa has the unique opportunity to become an industry leader and help shift billions of dollars away from climate destruction and into companies that define the new economic paradigm in a safe, just, and sustainable world. We would appreciate the opportunity to meet with you and show you the details of our scorecard.</p>

        <p>Thank you for your time and consideration, and we look forward to hearing back from you. </p>

        <AndrewBeharSignature />

      </blockquote>
    )
  }
}
